import { useCallback, useState } from 'react';

const STORAGE_KEY = 'snappy.favMarkets.v1';

function loadFavorites(): string[] {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed: unknown = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed)
            ? parsed.filter((c): c is string => typeof c === 'string')
            : [];
    } catch {
        return [];
    }
}

/** Starred markets, persisted to localStorage, pinned to the list top. */
export function useFavoriteMarkets() {
    const [favorites, setFavorites] = useState<string[]>(loadFavorites);

    const toggleFavorite = useCallback((coin: string) => {
        setFavorites((prev) => {
            const next = prev.includes(coin)
                ? prev.filter((c) => c !== coin)
                : [...prev, coin];
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            } catch {
                // storage unavailable — favorites just won't persist
            }
            return next;
        });
    }, []);

    return { favorites, toggleFavorite };
}
